$(function () {
    $('.language-selector').on('click', function () {
        var self = this;
        var currentUrl = window.location.href;
        $.ajax({
            url: '/locale/set',
            type: 'POST',
            dataType: 'json',
            data: {locale: $(self).data('locale')}
        }).done(function () {
            location.replace(currentUrl);
            location.reload();
        });
    });
});